import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { themeStyle, themeStyleDark } from "../components/Components";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";
import {
  ContentSideBySide,
  ContentSideBySideInv,
  ThreeSideBySide,
  Hero,
  Gallery,
  Stats,
  SpacerV,
} from "../components/Hero";
import { API_URL } from "../actions/auth";
import axios from "axios";
import { useNavigate } from "react-router";
import { TypeAnimation } from "react-type-animation";
import Lottie from "react-lottie";
import {
  OurProcess,
  Advantages,
  YouWillGet,
  Collage,
  FAQ2,
  Collage2,
  Trust,
  Tailor,
} from "../components/Sections";
import { layout } from "../components/Layout";

export default function PublishersManagement() {
  const [news, setNews] = useState([]);
  const navigate = useNavigate();
  const state = useSelector((state) => state);
  const dark = false;
  function getContent() {
    return (
      <div className="main">
        <Sidebar />
        <div
          className="anigrad"
          style={{ backgroundColor: dark ? "#111" : "white" }}
        >
          <div
            style={{
              height: state.auth.isMobile ? "130vh" : "100vh",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              width: "100vw",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "flex-start",
                alignItems: "flex-start",
                width: "75vw",
              }}
            >
              <div
                style={{
                  marginTop: state.auth.isMobile
                    ? state.auth.isTablet
                      ? "-300px"
                      : "-135px"
                    : "0px",
                  fontSize: state.auth.isMobile ? "25px" : "6vh",
                  color: "white",
                  zIndex: 999,
                  textAlign: "left",
                  marginBottom: "25px",
                  fontWeight: "bold",
                }}
              >
                <div
                  style={{
                    fontSize: layout.heading2[state.auth.view],
                  }}
                >
                  Maximize Revenue with Strategic Publisher Management
                </div>
              </div>
              <div
                style={{
                  fontSize: layout.textMedium[state.auth.view],
                  color: "white",
                  zIndex: 999,
                  textAlign: "left",
                }}
              >
                We optimize publisher partnerships and streamline ad inventory
                management. Our structured approach improves monetization
                strategies and ensures that digital properties generate
                sustainable revenue.
              </div>
              <button
                style={{
                  marginTop: "6vh",
                  filter: dark ? "invert(0)" : "invert(1)",
                }}
                onClick={() => {
                  navigate("/get-a-quote/");
                }}
                className="squishy"
              >
                Request a free estimate
              </button>
              <div
                style={{
                  display:
                    state.auth.isMobile || state.auth.view == "TABP"
                      ? "none"
                      : "block",
                }}
              >
                <Tailor
                  invert
                  title1="Publisher-Focused"
                  subtitle1="Optimize partnerships to grow revenue."
                  title2="Data-Driven Insights"
                  subtitle2="Track performance and maximize earnings."
                  title3="Simplified Management"
                  subtitle3="Streamline workflows for better results."
                />
              </div>
            </div>
          </div>
          <Stats />
          {state.auth.isTablet ? (
            <SpacerV height={"300px"} background="#111" />
          ) : (
            ""
          )}
          <ContentSideBySide
            dark={dark}
            title={
              <h2>
                Publisher Management Solutions for Higher Revenue and Better
                Optimization
              </h2>
            }
            subtitle={
              <div>
                At Riches Media Digital, we handle publisher management with
                precision and strategy.
                <br />
                <ul>
                  {" "}
                  <li>
                    <b>Optimize ad placements for higher earnings.</b>
                  </li>
                  <li>
                    <b>Refine inventory to maximize fill rates.</b>
                  </li>
                  <li>
                    <b>Boost revenue and engagement.</b>
                  </li>
                </ul>
              </div>
            }
            image={
              <Lottie
                options={{
                  loop: true,
                  autoplay: true,
                  animationData: require("../img/marketing (5).json"),
                  rendererSettings: {
                    preserveAspectRatio: "xMidYMid slice",
                  },
                }}
                height={state.auth.isMobile ? 350 : 500}
                width={state.auth.isMobile ? 350 : 500}
                isStopped={false}
                isPaused={false}
              />
            }
          />
          <SpacerV height={"100px"} background={dark ? "#111" : "white"} />
          <OurProcess
            invert={!dark}
            step1={"Inventory and Yield Optimization"}
            step1description={
              "We analyze available ad inventory and refine pricing strategies. Our team optimizes ad formats and placement settings. We also implement demand path optimization to improve revenue efficiency."
            }
            step2={"Ad Quality and Compliance Management"}
            step2description={
              "We monitor ad quality and block low-value placements. Our team ensures that all ads meet platform guidelines. We also manage compliance with brand safety standards to maintain content integrity."
            }
            step3={"Demand Partnerships and Revenue Expansion"}
            step3description={
              "We connect publishers with premium demand sources and negotiate better deals. Our team integrates header bidding solutions and direct deals. We also refine ad serving strategies to increase revenue potential."
            }
            step4={"Data-Driven Performance Monitoring"}
            step4description={
              "We track key revenue indicators and optimize inventory performance. Our team analyzes fill rates and bid density. We also refine floor pricing to improve ad earnings."
            }
          />
          <Advantages
            invert={!dark}
            title={"Advantages of Our Publisher Management Services"}
            title1={"Higher Ad Revenue"}
            subtitle1={
              "We optimize inventory pricing and demand partnerships. This increases revenue and improves yield performance."
            }
            title2={"Better Ad Quality Control"}
            subtitle2={
              "We monitor ad placements and block low-quality creatives. This ensures that publishers maintain a premium user experience."
            }
            title3={"Stronger Demand Connections"}
            subtitle3={
              "We establish partnerships with high-quality demand sources. This expands monetization opportunities and improves competition for ad placements."
            }
            title4={"Streamlined Inventory Efficiency"}
            subtitle4={
              "We refine ad formats and pricing strategies. This improves fill rates and promises that ad slots generate maximum earnings."
            }
          />
          <ContentSideBySideInv
            dark={dark}
            title={<h2>Our Strategy for Publisher Growth</h2>}
            subtitle="At Riches Media Digital, we take a structured approach to publisher management. We combine inventory optimization and demand diversification to create revenue-focused solutions. Our strategies align with market trends and ensure sustainable income growth. This results in higher earnings and better ad efficiency."
            image={
              <img
                style={{ width: "100%", borderRadius: "25px" }}
                src={require("../img/webd.jpg")}
              />
            }
          />
          <SpacerV height={"100px"} background={dark ? "#111" : "white"} />
          <YouWillGet
            willget={"What Publisher Management Services Will You Get"}
            invert={!dark}
            title1={"Advanced Yield Optimization"}
            title2={"Premium Demand Partnerships"}
            title3={"Ad Quality / Compliance Management"}
            title4={"Real-Time Revenue Monitoring"}
            title5={"Custom Monetization Strategies"}
          />
          <div
            style={{
              display:
                state.auth.isMobile || state.auth.view == "TABP"
                  ? "none"
                  : "block",
            }}
          >
            <Trust invert />
          </div>
          <FAQ2
            invert={!dark}
            q1="What is publisher management?"
            a1="Publisher management focuses on optimizing digital ad inventory. It involves revenue optimization and ad quality control. It further includes managing demand partnerships to improve monetization."
            q2="Why is publisher management important?"
            a2="Effective publisher management improves ad revenue and increases efficiency. It also ensures that ad placements maintain quality and align with user experience standards."
            q3="How do you optimize ad inventory?"
            a3="We refine ad placements and adjust floor pricing. Our team also evaluates demand sources to improve yield and maximize revenue opportunities."
            q4="How do you maintain ad quality?"
            a4="We monitor ad content and block low-quality creatives. Our team ensures that all placements align with brand safety guidelines. We also maintain compliance with platform policies to protect publisher reputations."
            q5="How do you connect publishers with sources?"
            a5="We establish direct partnerships with premium advertisers and integrate header bidding. Our team also negotiates programmatic deals to increase competition for ad inventory."
            q6="How can publishers track revenue performance?"
            a6="We provide real-time dashboards that monitor ad earnings and inventory performance. Our team analyzes fill rates and bid metrics. We also offer revenue optimization strategies based on live data insights."
          />
        </div>
        <Footer />
      </div>
    );
  }

  return (
    <div
      style={{
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor:
          state.auth.theme == "dark"
            ? themeStyleDark.backgroundColor
            : themeStyle.backgroundColor,
        transition: "opacity 2s",
      }}
    >
      {getContent()}
    </div>
  );
}
